import {
  DEFAULT_USER_SETTINGS,
  type User,
} from "@-/dev.improve.haniverse.database.schemas.actor.schema._tables.user";

/**
 * Constructor-default actor `user` row used before the database singleton is
 * available. Setting values match the table column defaults so synchronous
 * render reads and a freshly inserted database row start from identical state.
 *
 * The sentinel identity must never be persisted or used for actor-owned DB
 * writes; async query/mutation contexts fetch the authoritative user row first.
 */
export const createDefaultUser: User = {
  ...DEFAULT_USER_SETTINGS,
  createdAt: "1970-01-01T00:00:00.000Z",
  deletedAt: null,
  id: "unhydrated-actor-user",
  updatedAt: null,
};
